import { render, staticRenderFns } from "./contacter.vue?vue&type=template&id=2e82c962&scoped=true&"
import script from "./contacter.vue?vue&type=script&lang=js&"
export * from "./contacter.vue?vue&type=script&lang=js&"
import style0 from "./contacter.vue?vue&type=style&index=0&id=2e82c962&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82c962",
  null
  
)

export default component.exports